import React, { useContext, useState, useEffect } from "react";
import PropTypes from "prop-types";
import format from "lib/format";
import ImageCard from "Components/Fragment/ImageCard";
import {
  Activity,
  Classroom,
  Online,
  Program,
  SurveyToComplete,
} from "./Types";
import {
  PROP_TYPE_PROGRAM_COURSE,
  PROP_DEFAULT_PROGRAM_COURSE,
} from "../../../propTypes";
import {
  StyledCardBanner,
  StyledCardIconContainer,
  StyledCardLockIconContainer,
  StyledCardLockInformationTextBox,
} from "../../../functions";
import LangContext from "../../../langContext";
import CardIcon from "./CardIcon";
import * as CONSTANTS from "../../../constants";

//Den här komponenten bör vi extrahera ut som (Course?)Card till lib
const ProgramCard = (props) => {
  const languageContext = useContext(LangContext);
  const {
    course,
    displayImage,
    activityId,
    onRefresh,
    isPortalOverview,
    programParticipant,
    isPreview,
    isManager,
  } = props;

  const [completed, setCourseCompleted] = useState(course.completed);
  const isSurvey = course.type === CONSTANTS.COURSE_TYPE_SURVEY_TO_COMPLETE;
  const TYPE_ACTIVITY =
    course.type === CONSTANTS.COURSE_TYPE_ACTIVITY ||
    course.type === CONSTANTS.COURSE_TYPE_COMMON_ACTIVITY ||
    course.type === CONSTANTS.COURSE_TYPE_NEW_COMMON_ACTIVITY;
  let streamType =
    course.type === CONSTANTS.COURSE_TYPE_ONLINE
      ? "coursecoursecatalogue"
      : "courseobjectimage";
  const courseImageId = course.courseId
    ? course.courseId
    : course.courseObjectId;
  const imageUrlActivity = CONSTANTS.PROGRAM_ACTIVITY_IMAGE;
  const imageUrlCourse = course.image
    ? format.url(
        `/utils/streamfile.aspx?type=${streamType}&param=${courseImageId}/${encodeURIComponent(
          course.image,
        )}`,
      )
    : isPortalOverview
      ? CONSTANTS.PROGRAM_COURSE_IMAGE_PORTALOVERVIEW
      : CONSTANTS.PROGRAM_COURSE_IMAGE;

  const blankImgUrl = isPortalOverview
    ? CONSTANTS.PROGRAM_COURSE_IMAGE_BLANK_PORTALOVERVIEW
    : CONSTANTS.PROGRAM_COURSE_IMAGE_BLANK;

  let imageUrl = TYPE_ACTIVITY ? imageUrlActivity : imageUrlCourse;

  if (isSurvey) {
    imageUrl = CONSTANTS.PROGRAM_SURVEY_IMAGE;
  }

  const showImage = displayImage ? imageUrl : blankImgUrl;

  const cardHeader = isPortalOverview ? (
    `${course.title}`
  ) : isSurvey ? (
    `${course.order}) ${languageContext(course.title)}`
  ) : (
    <div
      id="programStepCardTitle"
      className="elipssis"
      title={course.title}
    >{`${course.order}) ${course.title}`}</div>
  );
  const cardHeaderHover = isPortalOverview
    ? `${course.title}`
    : isSurvey
      ? `${course.order}) ${languageContext(course.title)}`
      : `${course.order}) ${course.title}`;

  const setCompleted = (completed) => {
    setCourseCompleted(completed);
    onRefresh();
  };

  useEffect(() => {
    setCourseCompleted(course.completed);
  }, [course]);

  return (
    <ImageCard image={showImage} title={cardHeader} hovertext={cardHeaderHover}>
      {!isSurvey &&
        (isPortalOverview ? (
          <StyledCardIconContainer>
            <CardIcon type={course.type} />
          </StyledCardIconContainer>
        ) : (
          <CardIcon type={course.type} />
        ))}
      {course.mandatory && !completed && course.microsoftTeamId && (
        <StyledCardBanner>
          <span className="tag-microsoftTeams" id="cardBannerMSTeams">
            {languageContext("connectedToTeams")}
          </span>
          <span className="tag-negative" id="cardBannerMandatory">
            {languageContext("mandatory")}
          </span>
        </StyledCardBanner>
      )}
      {course.mandatory && !completed && !course.microsoftTeamId && (
        <StyledCardBanner>
          <span className="tag-negative" id="cardBannerMandatory">
            {languageContext("mandatory")}
          </span>
        </StyledCardBanner>
      )}
      {!course.mandatory && !completed && course.microsoftTeamId && (
        <StyledCardBanner>
          <span className="tag-microsoftTeams" id="cardBannerMSTeams">
            {languageContext("connectedToTeams")}
          </span>
        </StyledCardBanner>
      )}
      {completed && (
        <StyledCardBanner>
          <span className="tag-completed">{languageContext("completed")}</span>
        </StyledCardBanner>
      )}

      {course.numberOfDaysUntilRegistration > 0 && !course.completed && (
        <StyledCardLockIconContainer className="card-course-icon">
          <StyledCardLockInformationTextBox className="center tag">
            <p>
              {languageContext("unlocksin")}{" "}
              {course.numberOfDaysUntilRegistration}{" "}
              {languageContext("days").toLowerCase()}
            </p>
          </StyledCardLockInformationTextBox>
        </StyledCardLockIconContainer>
      )}
      {!isPortalOverview && !course.isActiveStep && (
        <StyledCardLockIconContainer className="card-course-icon course-icon-locked" />
      )}

      {course.type === CONSTANTS.COURSE_TYPE_ONLINE && (
        <Online
          course={course}
          setCompleted={setCompleted}
          isPortalOverview={isPortalOverview}
          programParticipant={programParticipant}
          isPreview={isPreview}
        />
      )}
      {course.type === CONSTANTS.COURSE_TYPE_CLASSROOM && (
        <Classroom
          course={course}
          activityId={
            isPortalOverview ? course.courseObjectActivityId : activityId
          }
          isPortalOverview={isPortalOverview}
          isPreview={isPreview}
        />
      )}
      {course.type === CONSTANTS.COURSE_TYPE_PROGRAM && (
        <Program
          course={course}
          activityId={
            isPortalOverview ? course.courseObjectActivityId : activityId
          }
          isPreview={isPreview}
          isPortalOverview={isPortalOverview}
        />
      )}
      {isSurvey && (
        <SurveyToComplete
          course={course}
          activityId={
            isPortalOverview ? course.courseObjectActivityId : activityId
          }
          isPreview={isPreview}
        />
      )}
      {TYPE_ACTIVITY && (
        <Activity
          activity={course}
          setCompleted={setCompleted}
          isPreview={isPreview}
          isManager={isManager}
        />
      )}
    </ImageCard>
  );
};

ProgramCard.propTypes = {
  course: PROP_TYPE_PROGRAM_COURSE,
  displayImage: PropTypes.bool,
};

ProgramCard.defaultProps = {
  course: PROP_DEFAULT_PROGRAM_COURSE,
  displayImage: false,
};

export default ProgramCard;
